import OrderTicket from "./OrderTicket";
export default OrderTicket;
